var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTapeRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 294,
    viewBox: "0 0 1440 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_46086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1637,
    height: 188.78,
    transform: "matrix(-0.988728 0.14972 0.14972 0.988728 1551.55 0.84668)",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 1629.11 -41.335)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 1395.03 -5.88965)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 1160.96 29.5557)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 926.889 65)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 692.816 100.444)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 458.744 135.89)",
    fill: "#FBD34E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 474,
    transform: "matrix(-0.917662 -0.397361 -0.397361 0.917662 224.671 171.334)",
    fill: "#FBD34E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_46086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1637,
    height: 188.78,
    fill: "white",
    transform: "matrix(-0.988728 0.14972 0.14972 0.988728 1551.55 0.84668)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapeRight);
export default __webpack_public_path__ + "static/media/tape-right.7c579b7848b216f9ff894d8571316aef.svg";
export { ForwardRef as ReactComponent };